import { render, staticRenderFns } from "./ConfigDashboardEditSidebar.vue?vue&type=template&id=37001f6c&scoped=true"
import script from "./ConfigDashboardEditSidebar.vue?vue&type=script&lang=js"
export * from "./ConfigDashboardEditSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConfigDashboardEditSidebar.vue?vue&type=style&index=0&id=37001f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37001f6c",
  null
  
)

export default component.exports